import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import {
    FirebaseService,
    FirebaseConfigKey,
} from '../../../../services/FirebaseService'
import { liabilityLimitPretty } from '../../../../services/utils'
import { isMobile } from 'react-device-detect'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { PolicyDroneView } from '../../../Core/Hull/PolicyDroneView'
import { PolicyEquipmentView } from '../../../Core/Hull/PolicyEquipmentView'
import { HullManage } from '../../../Hull/HullManage'
import {
    EventEmitterService,
    EventKey,
} from '../../../../services/EventEmitterService'
import PolicyExtensionContext from '../../../../context/PolicyHullExtensionContext'
import { PolicyRenewalContextStore } from '../../../../context/PolicyRenewalContext'
import { SUBSCRIPTION_STATE } from '../../../../models/insurance-models/PolicySubscriptionState'

var classNames = require('classnames')

interface PolicyHullSectionProps {
    onModify: Function;
    insurance: ActiveInsuranceModel;
}

export const PolicyHullSection = ({ insurance }: PolicyHullSectionProps) => {
    const policyRenewalContext = useContext(PolicyRenewalContextStore)

    const onModify = () => {
        EventEmitterService.dispatch(EventKey.OPEN_HULL_MANAGE_WINDOW)
    }

    let renewalOffer = policyRenewalContext.renewalOffers.find(
        (o) => o.liabilityLimit == insurance.subscription.liabilityLimit
    )

    return (
        <React.Fragment>
            <FlexView className="space-between margin-bottom-basic">
                <div className="text-body bold black">
                    {FirebaseService.getValue(
                        FirebaseConfigKey.HULL_HEADER_TEXT
                    )}
                </div>
                {insurance.isActiveOrSchedule() && (
                    <div
                        onClick={onModify}
                        className="text-small blue underline bold clickable"
                    >
                        Modify
                    </div>
                )}
            </FlexView>

            {policyRenewalContext.insuranceSubscriptionState ==
                SUBSCRIPTION_STATE.CURRENT && (
                <>
                    {insurance.insuredDrones.map((drone, index) => (
                        <div key={index} className="margin-top-basic">
                            <PolicyDroneView
                                drone={drone}
                                dronePremium={drone.premium}
                                droneDeductible={drone.deductible}
                            />
                        </div>
                    ))}
                    {insurance.insuredEquipment.map((equipment, index) => (
                        <div key={index} className="margin-top-basic">
                            <PolicyEquipmentView
                                equipment={equipment}
                                equipmentPremium={equipment.premium}
                                equipmentDeductible={equipment.deductible}
                            />
                        </div>
                    ))}
                </>
            )}

            {policyRenewalContext.insuranceSubscriptionState ==
                SUBSCRIPTION_STATE.RENEWAL &&
                renewalOffer && (
                    <>
                        {renewalOffer.drones.map((drone, index) => (
                            <div key={index} className="margin-top-basic">
                                <PolicyDroneView
                                    drone={drone}
                                    dronePremium={
                                        drone.premium /
                                        renewalOffer.avgFlightScoreMultiplier
                                    }
                                    droneDeductible={drone.deductible}
                                />
                            </div>
                        ))}
                        {renewalOffer.equipment.map((equipment, index) => (
                            <div key={index} className="margin-top-basic">
                                <PolicyEquipmentView
                                    equipment={equipment}
                                    equipmentPremium={equipment.premium}
                                    equipmentDeductible={equipment.deductible}
                                />
                            </div>
                        ))}
                    </>
                )}

            <PolicyExtensionContext>
                <HullManage insurance={insurance} />
            </PolicyExtensionContext>
        </React.Fragment>
    )
}
